import { render, staticRenderFns } from "./disposalCard.vue?vue&type=template&id=3f834960&scoped=true"
import script from "./disposalCard.vue?vue&type=script&lang=js"
export * from "./disposalCard.vue?vue&type=script&lang=js"
import style0 from "./disposalCard.vue?vue&type=style&index=0&id=3f834960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f834960",
  null
  
)

export default component.exports